module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/crocodile-star4.dd6b1d2a.png";